// (function () {
//     angular
//         .module('estadisticas')
//         .controller('FiltrosGraficoCtrl', FiltrosGraficoCtrl);
import angular from 'angular';

    FiltrosGraficoCtrl.$inject = ['$log', '$scope', '$http', 'FiltrosActivos', 'FiltrosCache', '$timeout'];
    export default function FiltrosGraficoCtrl($log, $scope, $http, FiltrosActivos, FiltrosCache, $timeout) {

        var TAG = 'FiltrosGraficoCtrl: ';
        $log.debug(TAG + 'Entra en la vista');

        var vm = this;
        vm.loading = {
            datos: true
        };

        FiltrosActivos.updateFilters(vm.grafico.variable_principal);

        vm.filtros = FiltrosActivos.getFiltros();
        vm.datosFiltros = {};
        cargarFiltros();

        vm.periodos = [
            {clave: 'mes_actual', nombre: 'Mes actual'},
            {clave: 'mes_pasado', nombre: 'Mes pasado'},
            {clave: 'anyo_actual', nombre: 'Año actual'},
            {clave: 'anyo_pasado', nombre: 'Año pasado'},
            {clave: 'trimestre_actual', nombre: 'Trimestre actual'},
            {clave: 'trimestre_pasado', nombre: 'Trimestre pasado'}
        ];
        vm.opcionesFecha = [
            {label: 'Rango de fechas', value: 'fecha_fija'},
            {label: 'Periodo', value: 'fecha_periodo'}
        ];
        vm.tipoFiltroFecha = 'fecha_fija';

        vm.onCambiaTipoFecha = function () {
            delete vm.filtros.periodo;
            delete vm.filtros.start;
            delete vm.filtros.end;
        };

        vm.renderUsuario = function (usuario) {
            var texto = usuario.codusuario;
            if (usuario.nombre || usuario.apellidos) {
                texto += ' (';
                if (usuario.nombre)
                    texto += usuario.nombre;
                if (usuario.apellidos)
                    texto += usuario.apellidos;
                texto += ')';
            }
            return texto;
        };
        vm.renderEntidad = function (entidad) {
            return entidad.nombre;
        };

        $scope.$watch(angular.bind(this, function () {
            return vm.filtros;
        }), function (newVal, oldVal) {
            var copiaFiltros = angular.copy(vm.filtros);
            var keys = Object.keys(copiaFiltros);
            var hayAlgunaNull = false;
            for (var i = 0; i < keys.length; i++) {
                if (copiaFiltros[keys[i]] == null || copiaFiltros[keys[i]].length == 0) {
                    delete copiaFiltros[keys[i]];
                    hayAlgunaNull = true;
                }
            }

            if (hayAlgunaNull) {
                vm.filtros = copiaFiltros;
                FiltrosActivos.setFiltros(copiaFiltros);
            } else {
                vm.onChange({valor: copiaFiltros});
            }

        }, true);

        vm.limpiarFiltros = function () {
            FiltrosActivos.limpiarFiltros();
            vm.filtros = FiltrosActivos.getFiltros();
        };

        vm.showFilterTypes = showFilterTypesFn;

        function showFilterTypesFn() {
            return vm.grafico.variable_principal == 'tareas' ||
                (vm.grafico.variable_principal == 'incidencias' && vm.grafico.variable_agrupacion == "incidencias_tipos");
        }

        function cargarFiltros() {
            FiltrosCache.getUnidadesGestion().then(function (datos) {
                vm.datosFiltros.unidadesGestion = datos;
            });
            FiltrosCache.getOrigenes().then(function (datos) {
                vm.datosFiltros.origenes = datos;
            });
            FiltrosCache.getDistritos().then(function (datos) {
                vm.datosFiltros.distritos = datos;
            });

            if (vm.grafico.variable_principal == 'incidencias'){
                FiltrosCache.getEstadosIncidencia().then(function (datos) {
                    vm.datosFiltros.estadosIncidencia = datos;
                });
            }
            if (showFilterTypesFn())
                FiltrosCache.getTipos().then(function (datos) {
                    vm.datosFiltros.tipos = datos;
                });

            if (vm.grafico.variable_principal == 'tareas') {
                FiltrosCache.getTecnicos().then(function (datos) {
                    vm.datosFiltros.tecnicos = datos;
                });
                FiltrosCache.getReparadores().then(function (datos) {
                    vm.datosFiltros.reparadores = datos;
                });
                FiltrosCache.getEntidadEstudio().then(function (datos) {
                    vm.datosFiltros.entidadesEstudio = datos;
                });
                FiltrosCache.getEntidadReparadora().then(function (datos) {
                    vm.datosFiltros.entidadesReparadoras = datos;
                });

                FiltrosCache.getEstadosEstudio().then(function (datos) {
                    vm.datosFiltros.estadosEstudio = datos;
                });

                FiltrosCache.getEstadosReparacion().then(function (datos) {
                    vm.datosFiltros.estadosReparacion = datos;
                });
            }
        }
    }
// })();